module.exports = __webpack_public_path__ + "static/media/n30.2d0d3220.jpg";